<template>
  <div class="lista-materiales-anidada">
    <h4 class="sub-section-title">
      <IconPackageVariantClosed class="section-icon" />
      Materiales del Proceso
    </h4>
    <el-collapse
      v-if="materiales.length > 0"
      v-model="activeNames"
      accordion
    >
      <el-collapse-item
        v-for="(material, index) in materiales"
        :key="material.codigoMaterial || index"
        :name="index"
      >
        <template #title>
          <div class="material-header">
            <span class="material-index">{{ index + 1 }}</span>
            <span class="material-nombre">{{
              material.descripcionInterna || `Material ${index + 1}`
            }}</span>
            <span
              v-if="material.codigoEquivalente"
              class="material-codigo"
            >
              ({{ material.codigoEquivalente }})
            </span>
            <span
              v-if="material.esTinta"
              class="material-badge tinta"
              >Tinta</span
            >
            <span
              v-else-if="material.esBarniz"
              class="material-badge barniz"
              >Barniz</span
            >
            <span
              v-if="!isStale"
              class="material-cantidad"
            >
              {{ formatearNumero(material.cantidad, 2) }}
              {{ unidadAbreviada(material.unidadMedida) }}
            </span>
          </div>
        </template>
        <material-detalle
          :material="material"
          :is-stale="isStale"
        />
      </el-collapse-item>
    </el-collapse>
    <div
      v-else
      class="empty-state-anidado"
    >
      Este proceso no consume materiales adicionales.
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import IconPackageVariantClosed from '~icons/mdi/package-variant-closed';
import { formatearNumero } from '@/shared/utils/format_produccion.js';
import MaterialDetalle from './material_detalle.vue';

defineProps({
  materiales: {
    type: Array,
    default: () => [],
  },
  isStale: {
    type: Boolean,
    default: false,
  },
});

const activeNames = ref(null);

function unidadAbreviada(unidad) {
  const map = {
    KILOGRAMOS: 'kg',
    METROS_CUADRADOS: 'm²',
    METROS_LINEALES: 'm',
    UNIDADES: 'u',
    GRAMOS: 'g',
  };
  return map[unidad] || unidad || '';
}
</script>

<style scoped>
.lista-materiales-anidada {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px dashed #e4e7ed;
}

.sub-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 6px;
  text-transform: uppercase;
}

.section-icon {
  font-size: 16px;
  color: #909399;
}

.material-header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.material-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #909399;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}

.material-nombre {
  font-weight: 500;
  color: #303133;
  font-size: 13px;
}

.material-codigo {
  font-size: 11px;
  color: #909399;
  font-family: 'Fira Code', monospace;
}

.material-badge {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.material-badge.tinta {
  background: #fdf6ec;
  color: #e6a23c;
}

.material-badge.barniz {
  background: #f0f9eb;
  color: #67c23a;
}

.material-cantidad {
  font-family: 'Fira Code', monospace;
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  margin-left: auto;
  padding-right: 8px;
}

.empty-state-anidado {
  color: #909399;
  font-size: 12px;
  font-style: italic;
  padding: 8px 0;
}
</style>
